module.exports = __webpack_public_path__ + "img/五塔寺.00665367.png";